
import { IonApp, IonRouterOutlet, IonSplitPane } from "@ionic/vue";
import { defineComponent, ref } from "vue";

import zhCn from "element-plus/dist/locale/zh-cn.mjs";
//此处引用会报错，需要在tsconfig.json里的compilerOptions加入noImplicitAny: false

export default defineComponent({
  name: "App",
  components: {
    IonApp,
    IonRouterOutlet,
  },
  setup() {
    const lang: any = ref(zhCn);
    return {
      lang,
    };
  },
});
